import { render, staticRenderFns } from "./WootButton.vue?vue&type=template&id=06504b82&"
import script from "./WootButton.vue?vue&type=script&lang=js&"
export * from "./WootButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06504b82')) {
      api.createRecord('06504b82', component.options)
    } else {
      api.reload('06504b82', component.options)
    }
    module.hot.accept("./WootButton.vue?vue&type=template&id=06504b82&", function () {
      api.rerender('06504b82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/ui/WootButton.vue"
export default component.exports